import { CodedProperty, SprintQueryResult, useSprintQuery } from "sprint-common-web";

import { useCachedAdminApi } from "../../api/admin-api/useCachedAdminApi";
import { DataHooksQueryKey } from "./DataHooksQueryKey";

export const useDynamicSubtitles = (): SprintQueryResult<CodedProperty[]> => {
    const { getDynamicSubtitles } = useCachedAdminApi();

    return useSprintQuery<CodedProperty[]>({
        queryKey: [DataHooksQueryKey.DynamicSubtitles],
        queryFn: async (): Promise<CodedProperty[]> => {
            const response = await getDynamicSubtitles();
            return response.items;
        }
    });
};
